import { BaseText } from 'aimo-ui';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { testIdentifiers } from 'utils/testIdentifiers';

type ValidityProps = {
  date: Date;
  testID?: string;
  mode?: 'date' | 'time' | 'datetime';
};

export const Validity = ({ date, testID, mode = 'date' }: ValidityProps) => {
  const { t } = useTranslation();
  const today = new Date();

  const getValidDate = (selectedDate: Date) => {
    if (mode === 'datetime') {
      return format(selectedDate, 'd.M.yyyy HH:mm');
    }

    if (today.toDateString() === selectedDate.toDateString()) {
      return t('longTermParking.validImmediately');
    }
    return format(new Date(selectedDate), 'd.M.Y HH:mm');
  };

  return (
    <BaseText {...testIdentifiers(testID as string)}>
      {date && getValidDate(date)}
    </BaseText>
  );
};

export default Validity;
